import IconButton from '@/components/Button/IconButton'
import Input from '@/components/Input'
import SelectGame from '@/components/Select/SelectGame'
import { searchIcon } from '@/images'
import { TypeLoadData } from '@/interfaces/Fetcher'
import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import style from '../styles/tournaments.module.scss'

interface IProps {
  handleFilter: TypeLoadData
  initFilters: any
}

const Filters = ({ handleFilter, initFilters }: IProps): React.ReactElement => {
  const [filter, setFilter] = useState({
    q: undefined,
    version: undefined,
    page_size: initFilters.page_size
  })

  const handleVersionChange = (e): void => {
    const newFiltres = { ...filter, version: e.target.value }
    setFilter(newFiltres)
    handleFilter(1, newFiltres)
  }

  const inputSearch = (e): void => setFilter({ ...filter, q: e.target.value })

  const onSubmit = (): void => handleFilter(1, filter)

  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.filters}>
        <Input
          onGx-input={inputSearch}
          type='text'
          theme='secondary'
          placeholder='Поиск...'
          className={style.filters_search}
        >
          <IconButton
            type='submit'
            theme='red'
            size='medium'
            slot='suffix'
            className={style.filters_search__button}
          >
            <GxIcon src={searchIcon} className={style.filters_search__icon} />
          </IconButton>
        </Input>
        <SelectGame
          clearable
          onGx-change={handleVersionChange}
          theme='secondary'
          className={style.filters__game}
        />
      </div>
    </GxForm>
  )
}

export default Filters
